import { atom, selector, GetRecoilValue } from "recoil";
import { LockedVoucherType, Order } from "../types";
import GlobalSharedStateClass from "../util/globalSharedStateClass";
import { SnackbarType } from "@workspace/shared";

export const snackbarAtom = atom<SnackbarType[]>({
  key: "snackbar",
  default: []
});

export const organizationsAtom = atom({
  key: "organizations",
  default: { data: [], meta: { count: 0 } },
});

export const selectedOrganizationAtom = atom({
  key: "selected_organizations",
  default: null,
});

export const selectedColumnsAtom = atom<string[]>({
  key: "selected_columns",
  default: [],
});

export const vouchersAtom = atom({
  key: "vouchers",
  default: [],
});

export const socketAtom = atom<WebSocket | undefined>({
  key: "socket",
  default: undefined,
});

export const lockedVouchersAtom = atom<LockedVoucherType[]>({
  key: "locked_vouchers",
  default: [],
});

export const subscribedVouchersIdAtom = atom<number[]>({
  key: "subscribed_vouchers_id",
  default: [],
});

export const vouchersOrderAtom = atom<{ orderBy: string; order: Order }>({
  key: "vouchersOrder",
  default: {
    orderBy: "scanningId",
    order: "desc",
  },
});

const cache = new GlobalSharedStateClass();
export const vouchersListCacheAtom = atom<{
  statuses: string[];
  voucherPerPage: number;
}>({
  key: "vouchersListCache",
  default: {
    statuses: cache.getSelectedStatuses(),
    voucherPerPage: cache.getRowsPerPage(),
  },
});

export const selectedTabAtom = atom<"fields" | "history">({
  key: "selectedTab",
  default: "fields",
});

export const refetchVoucherAtom = atom<number | null>({
  key: "refetch_voucher",
  default: null,
});

export const organizationSelector = selector({
  key: "get_selected_organization",
  get: ({ get }: { get: any }) => {
    return get(selectedOrganizationAtom);
  },
});

export const snackbarSelector = selector({
  key: "get_snackbar",
  get: ({ get }: { get: GetRecoilValue }) => {
    return get(snackbarAtom);
  },
});

export const vouchersOrderSelector = selector({
  key: "get_voucher_order",
  get: ({ get }: { get: GetRecoilValue }) => {
    return get(vouchersOrderAtom);
  },
});

export const selectedTabSelector = selector({
  key: "get_selected_tab",
  get: ({ get }: { get: GetRecoilValue }) => get(selectedTabAtom),
});

export const socketSelector = selector({
  key: "get_socket",
  get: ({ get }: { get: GetRecoilValue }) => get(socketAtom),
});

export const lockedVouchersSelector = selector({
  key: "get_locked_vouchers",
  get: ({ get }: { get: GetRecoilValue }) => get(lockedVouchersAtom),
});
